module.exports = __webpack_public_path__ + "static/img/3-4.8041df3c.png";